import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiDownload, FiMapPin } from 'react-icons/fi';
import Skeleton from '../components/ui/Skeleton';
import DocumentTitle from '../components/ui/DocumentTitle';
import { getAvatarUrl } from '../services/avatarService';
import './Home.css';

function Home() {
  const [avatarUrl, setAvatarUrl] = useState(null);

  useEffect(() => {
    async function fetchAvatar() {
      const url = await getAvatarUrl();
      setAvatarUrl(url);
    }
    fetchAvatar();
  }, []);

  return (
    <div className="page home-page">
      <DocumentTitle 
        title="Accueil" 
        description="." 
      />
      {/* Section Hero */}
      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <div className="hero-avatar">
              {avatarUrl ? (
                <img src={avatarUrl} alt="Théophile Yvars" className="avatar-image" />
              ) : (
                <Skeleton variant="avatar-large" width={300} height={300} className="avatar-skeleton" />
              )}
              <div className="avatar-status">
                <span className="status-dot"></span>
                <span>Ingénieur Logiciel @ SII · Mission Thales DMS</span>
              </div>
            </div>
            
            <div className="hero-text">
              <div className="hero-intro">
                <h1 className="hero-title">
                  Théophile Yvars
                </h1>
                <h2 className="hero-subtitle">
                   Ingénieur Platform · DevSecOps, Cloud &amp; Kubernetes
                </h2>
              </div>

              <div className="hero-location">
                <FiMapPin />
                <span>Cagnes-sur-mer, France</span>
              </div>

              <p className="hero-description">
                Je conçois, sécurise et opère des plateformes cloud-native de bout en bout — Kubernetes, GitOps, CI/CD, observabilité — avec l&apos;objectif de porter cette expertise dans un rôle DevSecOps / Platform Engineer.
              </p>
              
              <div className="hero-actions">
                <Link to="/projects" className="btn btn-primary btn-lg">
                  Voir mes projets <FiArrowRight />
                </Link>
                <a href="/Theophile-Yvars-CV.pdf" className="btn btn-outline btn-lg" download="Theophile-Yvars-CV.pdf">
                  <FiDownload /> Télécharger CV
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home
